import styled, { createGlobalStyle } from "styled-components";
import { Form } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

export const FormContainer = styled(Form)`
  .form-control {
    margin-bottom: 1.8em;
    /* border-color: ${({ theme }) => theme.input.bg.primary};
    background-color: ${({ theme }) => theme.input.bg.primary}; */
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
    border-color: #d5d7da;
    background-color: #ffffff;
    padding: 10px 14px;
    font-size: 16px;
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: #111827;
      transition: background-color 5000s ease-in-out 0s;
    }

    &:focus {
      border: 1px solid #048af5 !important;
      border-color: #048af5 !important ;
      box-shadow: none;
    }

    &.input-form-field {
      /* background: ${({ theme }) => theme.input.bg.quaternary}; */
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_16};
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
      /* border: 1px solid ${({ theme }) => theme.card.border.quaternary}; */
      background: #ffffff;
      border: 1px solid #d5d7da;
      color: #111827;
      padding: 10px 14px;
    }

    &::placeholder {
      color: #717184;
      opacity: 1;
    }

    &.is-invalid {
      border-color: lightcoral;
    }
  }
  .padd-right {
    padding-right: 50px;
  }
  .form-error {
    color: ${({ theme }) => theme.modal.error.font.color} !important;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 10px;
    margin-top: -10px;
  }
  .input-form {
    position: relative;

    .input-form-label {
      font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
      line-height: 130%;
      /* color: ${({ theme }) => theme.input.font.primary}; */
      color: #414651;
      margin-bottom: 10px;

      &:focus {
        background-color: aquamarine;
      }
    }

    .input-password-wrapper {
      position: relative;

      svg {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #535862;
      }
    }
  }

  .react-tel-input {
    .flag-dropdown {
      background: ${({ theme }) => theme.input.bg.quaternary};
      border: 1px solid #e3e3e8;
      color: ${({ theme }) => theme.input.font.primary};
      padding: 7px 12px;
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: 1rem;

      &.is-invalid {
        border-color: lightcoral;
      }

      .selected-flag {
        background: transparent;
      }
    }

    .country-list {
      background: ${({ theme }) => theme.dropdown.bg.primary};
      border: 1px solid ${({ theme }) => theme.input.border.color};
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.22);
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_5};
      color: ${({ theme }) => theme.dropdown.font.primary};

      .country.highlight {
        background: ${({ theme }) => theme.dropdown.hover.primary};
      }

      .country:hover {
        background: ${({ theme }) => theme.dropdown.hover.primary};
      }

      .search {
        background: ${({ theme }) => theme.dropdown.bg.primary};
      }

      .search-box {
        background: ${({ theme }) => theme.input.bg.tertiary};
        border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
        border: 1px solid ${({ theme }) => theme.input.border.color};
        color: ${({ theme }) => theme.input.font.primary};
        padding: 10px 15px;
        width: 90%;
      }
    }
  }

  .phone-form-field {
    background: ${({ theme }) => theme.input.bg.quaternary};
    border: 1px solid ${({ theme }) => theme.card.border.quaternary};
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
    color: ${({ theme }) => theme.input.font.primary};
    padding: 10px 15px 10px 80px;
    width: 100%;

    &:focus {
      outline: none;
    }

    &.is-invalid {
      border-color: lightcoral;
    }

    &::placeholder {
      color: #717184;
      opacity: 1;
    }
  }

  .form-check-label,
  .radio {
    color: ${({ theme }) => theme.input.font.primary};
  }
`;

export const InputTagsContainer = styled.div`
  .selected-tags {
    background: rgba(83, 91, 122, 0.8);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 0 5px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    width: 190px;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .selected-tags .remove-tag {
    display: none;
  }

  .tag {
    background: ${({ theme }) => theme.global.extraInfo.font.color};
    border-radius: 75px;
    color: ${({ theme }) => theme.global.color.quinary};
    padding: 2px 10px;
    margin-right: 5px;
  }

  input {
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    border: none;
    background-color: transparent;
    width: 100px;

    &::placeholder {
      color: ${({ theme }) => theme.input.placeholder.color} !important;
    }

    &:focus {
      outline: none;
    }
  }
`;

export const InputSearchContainer = styled.div`
  position: relative;

  .search-icon {
    position: absolute;
    left: 12px;
    top: 9px;
  }

  .search-input {
    color: ${({ theme }) => theme.input.font.primary} !important;
    padding: 0 60px 0 42px;
    width: 300px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid
      ${({ theme }) => theme.card.border.quaternary || "#E9EAEB"};
    font-size: 14px;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
    }

    &::placeholder {
      font-size: 14px;
      color: ${({ theme }) => theme.input.placeholder.color || "#9ca3af"};
    }
  }

  .keyboard-shortcut {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: ${({ theme }) => theme.card.bg.secondary || "#f5f5f5"};
    border: 1px solid ${({ theme }) => theme.card.border.quaternary};
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.input.font.primary};
    pointer-events: none;
  }

  .clear-search {
    position: absolute;
    right: 16px;
    top: 14px;
    height: 10px;
    width: 10px;
    cursor: pointer;
  }

  @media (max-width: 767px) {
    width: 100%;

    .search-input {
      width: 100%;
      padding: 0 50px 0 42px;
    }

    .keyboard-shortcut {
      display: none;
    }
  }

  @media (max-width: 480px) {
    .search-input {
      padding: 0 40px 0 35px;
      font-size: 13px;
    }

    .search-icon {
      left: 10px;
      top: 11px;
      width: 16px;
      height: 16px;
    }
  }
`;

export const SelectStyles = (theme) => ({
  option: (provided) => ({
    ...provided,
    color: theme.dropdown.font.secondary,
    opacity: 0.7,
    backgroundColor: theme.dropdown.bg.primary,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.dropdown.hover.primary,
    },
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: theme.input.bg.quaternary,
    color: theme.dropdown.font.secondary,
    border: `1.5px solid ${theme.card.border.quaternary}`,
    borderRadius: "50px",
    padding: "5px 10px",
    "&:hover": {
      borderColor: theme.dropdown.hover.secondary,
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: theme.dropdown.bg.primary,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme.dropdown.font.primary,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
  }),
  input: (provided) => ({
    ...provided,
    color: theme.dropdown.font.primary,
    height: "22px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: theme.dropdown.font.tertiary,
    fontSize: "14px",
    fontWeight: 400,
  }),
});

export const DateTimePickerContainer = styled.div`
  position: relative;

  .react-datepicker-wrapper {
    color: ${({ theme }) => theme.input.font.primary};
    width: 100%;

    .filter-form-control {
      background: ${({ theme }) => theme.input.bg.quaternary};
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      color: ${({ theme }) => theme.input.font.primary};
      padding: 10px 40px 10px 14px;
      font-size: 14px;
      font-weight: 400;
      transition: all 0.2s ease;

      &:hover {
        border-color: #c5c7cc;
      }

      &:focus {
        border-color: #2258f1;
        outline: none;
        box-shadow: 0 0 0 3px rgba(34, 88, 241, 0.1);
      }

      &::placeholder {
        color: #9ca3af;
        font-size: 14px;
      }
    }
  }

  .calendar-icon {
    position: absolute;
    top: 8px;
    right: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #717680;

    &:hover {
      color: #2258f1;
      transform: scale(1.05);
    }
  }
`;

export const DatePickerGlobalStyles = createGlobalStyle`
  /* DatePicker Popper */
  .react-datepicker-popper {
    z-index: 9999 !important;
  }

  /* Main DatePicker Container */
  .react-datepicker {
    font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI",
      sans-serif !important;
    border: 1px solid #e9eaeb !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
    background: #ffffff !important;
    padding: 16px !important;
  }

  /* Header */
  .react-datepicker__header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #e9eaeb !important;
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
    padding: 16px 0 12px 0 !important;
  }

  .react-datepicker__current-month {
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #414651 !important;
    margin-bottom: 12px !important;
  }

  /* Day Names */
  .react-datepicker__day-names {
    display: flex !important;
    justify-content: space-around !important;
    margin-bottom: 4px !important;
  }

  .react-datepicker__day-name {
    color: #717680 !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    width: 36px !important;
    line-height: 36px !important;
    margin: 2px !important;
    text-transform: uppercase !important;
  }

  /* Month & Week */
  .react-datepicker__month {
    margin: 8px 0 !important;
  }

  .react-datepicker__week {
    display: flex !important;
    justify-content: space-around !important;
  }

  /* Day Cells */
  .react-datepicker__day {
    width: 36px !important;
    line-height: 36px !important;
    font-size: 14px !important;
    color: #414651 !important;
    border-radius: 50% !important;
    margin: 2px !important;
    transition: all 0.2s ease !important;
    font-weight: 400 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .react-datepicker__day:hover {
    background-color: #e8f0fe !important;
    color: #2258f1 !important;
    border-radius: 50% !important;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: #2258f1 !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    border-radius: 50% !important;
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__day--keyboard-selected:hover {
    background-color: #1a47c9 !important;
    color: #ffffff !important;
  }

  .react-datepicker__day--today {
    font-weight: 600 !important;
    color: #2258f1 !important;
  }

  .react-datepicker__day--today:not(.react-datepicker__day--selected) {
    background-color: transparent !important;
    border: 2px solid #2258f1 !important;
  }

  .react-datepicker__day--outside-month {
    color: #a4a7ae !important;
    opacity: 0.6 !important;
  }

  .react-datepicker__day--disabled {
    color: #d7d9de !important;
    cursor: not-allowed !important;
    opacity: 0.4 !important;
  }

  .react-datepicker__day--disabled:hover {
    background-color: transparent !important;
    color: #d7d9de !important;
  }

  /* Navigation Arrows */
  .react-datepicker__navigation {
    top: 28px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 50% !important;
    transition: all 0.2s ease !important;
    border: none !important;
  }

  .react-datepicker__navigation:hover {
    background-color: #f6f8fa !important;
  }

  .react-datepicker__navigation--previous {
    left: 16px !important;
  }

  .react-datepicker__navigation--next {
    right: 16px !important;
  }

  .react-datepicker__navigation-icon::before {
    border-color: #717680 !important;
    border-width: 2px 2px 0 0 !important;
    width: 8px !important;
    height: 8px !important;
    top: 12px !important;
  }

  .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
    border-color: #414651 !important;
  }

  /* Month & Year Dropdowns */
  .react-datepicker__month-dropdown-container,
  .react-datepicker__year-dropdown-container {
    margin: 0 4px !important;
  }

  .react-datepicker__month-dropdown,
  .react-datepicker__year-dropdown {
    background-color: #ffffff !important;
    border: 1px solid #e9eaeb !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    font-size: 14px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
  }

  .react-datepicker__month-option,
  .react-datepicker__year-option {
    padding: 8px 12px !important;
    color: #414651 !important;
    cursor: pointer !important;
    transition: background-color 0.15s ease !important;
  }

  .react-datepicker__month-option:hover,
  .react-datepicker__year-option:hover {
    background-color: #f6f8fa !important;
  }

  .react-datepicker__month-option--selected,
  .react-datepicker__year-option--selected {
    background-color: #e8f0fe !important;
    color: #2258f1 !important;
    font-weight: 600 !important;
  }

  .react-datepicker__month-read-view,
  .react-datepicker__year-read-view {
    border: 1px solid #e9eaeb !important;
    border-radius: 6px !important;
    padding: 4px 8px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #414651 !important;
    cursor: pointer !important;
    transition: all 0.15s ease !important;
    width: 110px;
  }

  .react-datepicker__month-read-view:hover,
  .react-datepicker__year-read-view:hover {
    background-color: #f6f8fa !important;
    border-color: #d7d9de !important;
  }

  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__year-read-view--down-arrow {
    border-color: #717680 !important;
    border-width: 2px 2px 0 0 !important;
    width: 6px !important;
    height: 6px !important;
    top: 9px !important;
    right: 6px !important;
  }

  /* Scrollbar Styling */
  .react-datepicker__month-dropdown::-webkit-scrollbar,
  .react-datepicker__year-dropdown::-webkit-scrollbar {
    width: 6px;
  }

  .react-datepicker__month-dropdown::-webkit-scrollbar-track,
  .react-datepicker__year-dropdown::-webkit-scrollbar-track {
    background: #f6f8fa;
    border-radius: 3px;
  }

  .react-datepicker__month-dropdown::-webkit-scrollbar-thumb,
  .react-datepicker__year-dropdown::-webkit-scrollbar-thumb {
    background: #d7d9de;
    border-radius: 3px;
  }

  .react-datepicker__month-dropdown::-webkit-scrollbar-thumb:hover,
  .react-datepicker__year-dropdown::-webkit-scrollbar-thumb:hover {
    background: #a4a7ae;
  }
`;
